export function PartnersSection() {
  return (
    <section className="py-12 px-4 md:px-6 bg-muted/30 border-y">
      <div className="container">
        <div className="text-center mb-6">
          <h2 className="text-2xl font-bold tracking-tighter sm:text-3xl">
            Discover Opportunities From Leading Companies
          </h2>
          <p className="mt-3 text-muted-foreground max-w-2xl mx-auto">
            NewLoop indexes open positions and professional profiles from top companies to create the most comprehensive career marketplace
          </p>
        </div>

        <div className="relative overflow-hidden">
          <div className="flex items-center justify-between py-6">
            <div className="flex items-center justify-center h-8 md:h-10 opacity-70 hover:opacity-100 transition-opacity">
              <div className="text-lg md:text-xl font-semibold">Affirm</div>
            </div>
            <div className="flex items-center justify-center h-8 md:h-10 opacity-70 hover:opacity-100 transition-opacity">
              <div className="text-lg md:text-xl font-semibold">ZoomInfo</div>
            </div>
            <div className="flex items-center justify-center h-8 md:h-10 opacity-70 hover:opacity-100 transition-opacity">
              <div className="text-lg md:text-xl font-semibold">Atlassian</div>
            </div>
            <div className="flex items-center justify-center h-8 md:h-10 opacity-70 hover:opacity-100 transition-opacity">
              <div className="text-lg md:text-xl font-semibold">JungleScout</div>
            </div>
            <div className="hidden md:flex items-center justify-center h-8 md:h-10 opacity-70 hover:opacity-100 transition-opacity">
              <div className="text-lg md:text-xl font-semibold">Stripe</div>
            </div>
            <div className="hidden lg:flex items-center justify-center h-8 md:h-10 opacity-70 hover:opacity-100 transition-opacity">
              <div className="text-lg md:text-xl font-semibold">Salesforce</div>
            </div>
            <div className="hidden xl:flex items-center justify-center h-8 md:h-10 opacity-70 hover:opacity-100 transition-opacity">
              <div className="text-lg md:text-xl font-semibold">Dropbox</div>
            </div>
          </div>
        </div>
        
        <p className="text-center text-sm text-muted-foreground mt-4">
          Our platform continuously analyzes hiring data from hundreds of companies
        </p>
      </div>
    </section>
  );
}